var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[[_c('div',{attrs:{"id":"ruleImg"}},[_c('img',{attrs:{"src":_vm.banners}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }